import {getFormattedWebsitePath} from "@/utilities";
import {useCurrencyStore} from "@/store/currency";

export default ({product = null, productReviews = null} = {}) => {

    const {name = '', images, description, manufacturer, price, has_stock, sku, isbn, rating} = product || {}

    const formattedManufacturer = manufacturer?.trim()

    // parse product description as we get it as a html string from api
    const formattedDescription = description ? description.replace(/(<([^>]+)>)/gi, '') : ''

    const {locale, t} = useI18n()

    const route = useRoute()

    const currencyStore = useCurrencyStore()
    const {currency} = storeToRefs(currencyStore)

    let extra = {}

    const date = new Date().setDate(new Date().getDate() + 5)
    const priceValidUntil = new Date(date).toISOString().substring(0, 10)

    let category = product?.category?.[0] || {}

    category = {
        '@type': 'Thing',
        name: category?.name?.trim() || '',
        url: getFormattedWebsitePath(category?.seo_url)
    }

    let reviews = []
    if (productReviews?.reviews?.length) {
        reviews = productReviews.reviews.map(review => {
            return {
                '@type': 'Review',
                name: review.author,
                reviewBody: review.text,
                reviewRating: {
                    '@type': 'Rating',
                    ratingValue: review.rating > 0 ? review.rating : 5,
                    bestRating: 5,
                    worstRating: 1
                },
                datePublished: review.date_added,
                author: {
                    '@type': 'Person',
                    name: review.author
                }
            }
        })
    } else {
        reviews = {
            '@type': 'Review',
            reviewRating: {
                '@type': 'Rating',
                ratingValue: 5,
                bestRating: 5,
                worstRating: 1
            },
            author: {
                '@type': 'Person'
            }
        }
    }

    const product_main_details = {
        url: getFormattedWebsitePath(route.path),
        price: price,
        priceValidUntil: priceValidUntil,
        priceCurrency: currency.value,
        availability: `https://schema.org/${has_stock ? 'InStock' : 'OutOfStock'}`,
        itemCondition: 'https://schema.org/NewCondition'
    }

    if (product?.special && product?.special?.length) {
        const special = product?.special[0] || {}
        const offer = {
            offers: {
                ...product_main_details,

                '@type': 'Offer',
                price: special?.priceWithoutCurrency,
                priceValidUntil: priceValidUntil,
                itemOffered: {'@id': '#Product'},
                offeredBy: {
                    '@id': '#Organization',
                    '@type': 'Organization',
                    name: t('niceone'),
                    url: getFormattedWebsitePath(),

                    logo: 'https://niceonesa.com/_nuxt/img/f53548c.png',
                    sameAs: [
                        'https://www.facebook.com/pg/niceonesa/about/',
                        'https://twitter.com/NICEONESA',
                        `https://www.instagram.com/niceonesa/?hl=en`,
                        'https://www.youtube.com/channel/UCu8c7LeOLpt1pPICrkHBKiw',
                        'https://www.linkedin.com/company/niceonesa/'
                    ]
                }
            }
        }

        extra = {...extra, ...offer}
    } else {
        extra = {...extra, offers: {...product_main_details}}
    }

    return {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name,
        image: images,
        description: formattedDescription,
        brand: {
            '@type': 'Brand',
            name: formattedManufacturer,
            url: getFormattedWebsitePath(formattedManufacturer)
        },
        manufacturer: formattedManufacturer,
        sku,
        isbn,
        category,
        review: reviews,
        aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: rating || 5,
            bestRating: 5,
            worstRating: 1,
            ratingCount: +productReviews?.review_total || 1,
            reviewCount: +productReviews?.review_total || 1
        },
        ...extra
    }
}
